import Service from "../AuthService";

const banner = {

    getAllBanners() {
        return Service.get(`/api/banners/all`);
    },

    updateBanners(data) {
        return Service.post(`/api/banners/store`, {
            desktop_img: data.desktop_img,
            mobile_img: data.mobile_img,
            page: data.page,
            is_slides: data.is_slides,
            url:data.url
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    }

};

export default banner;
